interface BreadcrumbItem {
  name: string;
  url: string;
}

interface FAQItem {
  question: string;
  answer: string;
}

interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'FAQPage';
  data?: Record<string, unknown>;
  breadcrumbItems?: BreadcrumbItem[];
  faqItems?: FAQItem[];
  pageUrl?: string;
  pageName?: string;
}

export default function SchemaOrg({
  type,
  data,
  breadcrumbItems,
  faqItems,
  pageUrl = 'https://qimanwu.com',
  pageName = '奇漫屋',
}: SchemaOrgProps) {
  let schema: Record<string, unknown>;

  switch (type) {
    case 'Organization':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '奇漫屋',
        url: 'https://qimanwu.com',
        description: '奇漫屋提供免费韩国漫画大全，支持在线和下拉式阅读。',
        ...data,
      };
      break;

    case 'WebSite':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '奇漫屋',
        url: 'https://qimanwu.com',
        inLanguage: 'zh-CN',
        ...data,
      };
      break;

    case 'WebPage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: pageName,
        url: pageUrl,
        isPartOf: {
          '@type': 'WebSite',
          name: '奇漫屋',
          url: 'https://qimanwu.com',
        },
        inLanguage: 'zh-CN',
        ...data,
      };
      break;

    case 'BreadcrumbList':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: (breadcrumbItems || []).map((item, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: item.name,
          item: item.url,
        })),
        ...data,
      };
      break;

    case 'FAQPage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: (faqItems || []).map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer,
          },
        })),
        ...data,
      };
      break;

    default:
      schema = { '@context': 'https://schema.org', ...data };
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}